import initApplication from './initApplication';
import handleLogicErrors from './handleLogicErrors';

const logic = [initApplication, handleLogicErrors];

export default logic;
